<div class="zeva-card zebot-container">
  <div class="card-header action-header">
    <div class="profile">
      <img class="bot-icon" src="/assets/icons/social-media/zeva-icon.png" />
      <span class="mat-headline-5">Alan</span>
      <span class="beta mat-small">beta</span>
    </div>
    <div>
      <button mat-icon-button (click)="minimize.emit()">
        <mat-icon>horizontal_rule</mat-icon>
      </button>
      <button mat-icon-button (click)="endChatFlag.set(true)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="card-body" #chatContainer>
    <div class="description">
      <mat-icon svgIcon="zebot" class="th-color-primary"></mat-icon>
      <span>Alan, our AI vehicle analytics assistant,<br/> knows your vehicle better than you do<br/> — and he's here to help!</span>
    </div>

    <div class="messages">
      <table class="message-table">
        <tr class="date"><td colspan="2">Today</td></tr>
  
        @for (message of messages; track message; let i = $index) {
          <tr
            class="line"
            [class.last]="i === messages.length - 1 || messages[i].sender !== messages[i + 1]?.sender"
          >
            <td class="pfp">
              @if (
                message.sender === 'bot' &&
                (i === messages.length - 1 || messages[i].sender !== messages[i + 1]?.sender)
              ) {
                <img src="/assets/icons/social-media/zeva-icon.png" />
              }
            </td>
            <td
              class="message sender__{{ message.sender }}"
            >
              <div class="bubble">
                @if (message.thinking) {
                  <span class="thinking">
                    <span class="th-background-as-text"></span>
                    <span class="th-background-as-text"></span>
                    <span class="th-background-as-text"></span>
                  </span>
                }
                @else {
                  <span>{{ message.text }}</span>
                }

                @if (message.feedback) {
                  <div class="feedback">
                    <button mat-icon-button color="accent" (click)="provideFeedback(true)">
                      <mat-icon>thumb_up</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="provideFeedback(false)">
                      <mat-icon>thumb_down</mat-icon>
                    </button>
                  </div>
                }
              </div>
            </td>
          </tr>
        }
      </table>
    </div>

    <div class="user-input th-background-depth">
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Message..."
          [disabled]="awaitingFeedback()"
          #userInput
          (keydown.enter)="sendMessage(userInput.value); userInput.value = ''"
        />
        <button
          matSuffix
          mat-icon-button
          [disabled]="awaitingFeedback() || !userInput.value"
          (click)="sendMessage(userInput.value); userInput.value = ''"
        >
          <mat-icon svgIcon="send"></mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</div>

<div
  class="end-chat-overlay"
  [class.visible]="endChatFlag()"
>
  <div class="backdrop" (click)="endChatFlag.set(false)"></div>
  <div class="zeva-card padded">
    <h4 class="mat-headline-4">End Chat</h4>
    <mat-divider />
    <p>Are you sure you want to end chat?</p>
    <div class="button-group">
      <button
        mat-button
        class="cancel"
        (click)="endChatFlag.set(false)"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="endChat()"
      >
        End Chat
      </button>
    </div>
  </div>
</div>
